import { render, staticRenderFns } from "./EcommTest.vue?vue&type=template&id=ef848006&"
import script from "./EcommTest.vue?vue&type=script&lang=js&"
export * from "./EcommTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports